import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { getLocalizedMonthNames } from 'utils/date';
import { displayRoundedNumber } from 'utils/misc';

import { BaseplanOverview } from 'RestAPIs/capacity-plan/analyzer';

import Table from 'components/shared/Table/Table';

const monthNames = getLocalizedMonthNames();

interface BaseplanTableProps {
  baseplans: BaseplanOverview[];
}

const BaseplanTable: FC<BaseplanTableProps> = ({ baseplans }) => {
  const { t } = useTranslation('common');

  const data = {
    columns: [t('description'), ...monthNames, t('yearTotal')],
    rows: baseplans.map(({ id, periods, isBasePlan }) => {
      const total = displayRoundedNumber(
        periods.reduce((acc, { hours }) => acc + hours, 0)
      );
      return {
        id,
        cells: [
          isBasePlan ? t('baseplan.name') : t('baseplan.workSupply'),
          ...periods.map(({ hours }) => displayRoundedNumber(hours)),
          total
        ]
      };
    })
  };

  return <Table data={data} />;
};

export default BaseplanTable;
